import { useSyncExternalStore } from "react";
import { ScanMode, scanModeStore } from "../common";

let currentScanMode = scanModeStore.get() ?? ScanMode.VERIFY_PRINT;
const listeners = new Set<() => void>();

function getScanMode() {
  return currentScanMode;
}

function subscribeToScanMode(listener: () => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function setScanMode(scanMode: ScanMode) {
  if (scanMode === currentScanMode) {
    return;
  }
  currentScanMode = scanMode;
  scanModeStore.set(scanMode);
  for (const listener of listeners) {
    listener();
  }
}

/*
 * Scan mode
 *
 * While we handle scanMode in the local storage store, we're providing it
 * here to centralize the scanning state from the context of the consumer
 */

export function useScanMode() {
  const scanMode = useSyncExternalStore(
    subscribeToScanMode,
    getScanMode,
    getScanMode,
  );
  return { scanMode, setScanMode };
}
